
/**
 **************** PC端事件响应 ****************
 */

//移动端点击某个系统
function mobileSystemClick() {
  $('.mobile-body .system-list').on('click', '.system-item', function (event) {
    event.preventDefault();
    $('.mobile-body .system-list .system-item.active').removeClass('active');
    $(this).addClass('active');
    $.message.alert('请在电脑端进行登录');
  });
  //首页 供采池列表数据类型切换
  $(".supply-warpper-mobile .release-title a").each(function (index){
    $(this).click(function() {
      //点击采购
      if (index == 0){
        $(".supply-warpper-mobile .procurement-content-homepage").css("display", "block");
        $(".supply-warpper-mobile .supply-content-homepage").css("display", "none");
        $(".supply-warpper-mobile .more-supply a").attr("href", "/supply");
      }
      else{//点击供应
        $(".supply-warpper-mobile .procurement-content-homepage").css("display", "none");
        $(".supply-warpper-mobile .supply-content-homepage").css("display", "block");
        $(".supply-warpper-mobile .more-supply a").attr("href", "/supply/2");
      }
    });
  });
}
//头部登录按钮点击
function headerLoginInit() {
  //移动端暂时不支持登录
  $('.mobile-body .header .login-button').on('click', () => {
    $.message.alert('请在电脑端进行登录');
  });
}
//手机页面头部导航
function mobileHeaderNavInit() {
  $('.header .list-icon').on('click', () => {
    layer.open({
      type: 1,
      content: $('.nav-template').html(),
      anim: false,
      className: 'nav-layer',
    })
  });
}
//轮播图
function carouselImageInit() {
  $('.carousel-image-container').each(function (index) {
    const className = `carousel-image-index-${index}`;
    $(this).addClass(className);
    const slides = $(this).find('.swiper-slide');
    if (slides.length < 2) {
      $(this).find('.swiper-pagination').hide();
    }
    const swiper = new Swiper(`.${className}`, {
      loop: slides.length > 1,
      autoplay: slides.length > 1,
      pagination: {el: `.${className} .swiper-pagination`,},
    });
  });
}

//产地甄选轮播图
function areaCarouselInit() {
  $('.area-image-container').each(function (index) {
    const className = `area-image-index-${index}`;
    $(this).addClass(className);
    const slides = $(this).find('.swiper-slide');
    if (slides.length < 5) {
      $(this).find('.swiper-button-next').hide();
      $(this).find('.swiper-button-prev').hide();
    }
    const swiper = new Swiper(`.${className}`, {
      slidesPerView : 4,
      slidesPerGroup : 1,
      spaceBetween : 10,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
  });
}

// 点击导航
function navigationInit() {
  $('.nav a').each(function(index) {
    const href = $(this).attr('href');
    if (location.href.indexOf(href) >= 0 && href) {
      $('.nav a').removeClass('nav-check');
      $(this).addClass('nav-check');
    }
    $(this).click(function() {
      $('.nav a').eq(index).addClass('nav-check').siblings().removeClass('nav-check');
    });
  });
}



//返回顶部
function toTopInit() {
  $('.go-top').on('click', () => {
    $('html,body').animate({scrollTop: 0}, 500)
  });
}

//专家咨询 打开关闭切换
function expertConsultationToggle() {
  var $ec = $('.expert-consultation');
  $ec.on('click', '.consultation-online', () => {
    $ec.toggleClass('show-left');
  }).on('click', '.expert-consultation-close-icon', () => {
    $ec.removeClass('show-left');
  });
}
const init = () => {
  mobileSystemClick();
  headerLoginInit();
  mobileHeaderNavInit();
  carouselImageInit();
  toTopInit();
  expertConsultationToggle();
  navigationInit();
  areaCarouselInit();  
};
module.exports = {init,areaCarouselInit};